import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { HeaderTemplateData } from '../dialog-data.interface';
import { GetRejectedSalesByDateGQL } from './../../../../../generated/gatewaygql';
import { PosSubmission } from './../../../../../models/daily-sales.model';
import { AuthenticationService } from './../../../../../services/authentication.service';
import { DailySalesEnum } from './../../../enum/daily-sales.enum';
import { RoutingUrl } from './../../../enum/routing-url.enum';

export interface DialogData {
    header: HeaderTemplateData
    date: Date;
}

export interface TableColumn {
    modifyDate: Date;
    RejectedBy: { userName: string };
    totalSalesAmt: number;
    remarks: string;
}

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'history-dialog',
    templateUrl: 'history-dialog.html',
    styleUrls: ['./history-dialog.scss']
})
export class HistoryDialogComponent implements OnInit {
    displayedColumns: string[] = ['tenantName', 'modifyDate', 'RejectedBy'];
    result: Date;
    header: HeaderTemplateData
    dataSource: Array<PosSubmission> = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: DialogData,
        private _dialogRef: MatDialogRef<HistoryDialogComponent>,
        private _getRejectedSalesByDateGQL: GetRejectedSalesByDateGQL,
        private _authService: AuthenticationService,
        private _router: Router
    ) {
        if (this._data != null) {
            this.header = _data.header
            this.result = _data.date;
        }
    }

    async ngOnInit() {
        await this.getRejectedRecords();
    }

    async getRejectedRecords() {
        const result = await this._getRejectedSalesByDateGQL.fetch({
            PropertyId: this._authService.userInfo.property?.propertyId,
            Date: this.result,
            Status: [DailySalesEnum.REJECTED]
        }).pipe(map(x => x.data.PropertyById.ActiveRentalContract)).toPromise();

        for (const item of result) {

            if (item.posSubmission.length > 0) {
                this.dataSource = this.dataSource.concat(item.posSubmission);
            }

        }
    }

    redirect(submissionId: number) {
        this._dialogRef.close();

        this._router.navigate([RoutingUrl.TENANT_SALES_SUBMISSION_DETAILS], { queryParams: { subId: submissionId } });
    }
}
